// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"889":"9eaad40e7710b40f","2768":"2f700a4c753f05aa"}[chunkId] + ".css";
};